function hydrateGwpImages(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll(".gwp-img").forEach((img) => {
    const dataSrc = img.getAttribute("data-src") || img.dataset.src;
    if (!dataSrc) return;
    const attrSrc = img.getAttribute("src");
    if (!attrSrc || attrSrc === window.location.href) {
      img.src = dataSrc;
    }
  });
}

function bindCartGwpCarousel(root) {
  if (!root || root.dataset.gwpMounted === "true") return;
  root.dataset.gwpMounted = "true";

  const track = root.querySelector("[data-gwp-track]");
  const prev = root.querySelector(".cart__gwp-nav--prev");
  const next = root.querySelector(".cart__gwp-nav--next");

  const scrollTrack = (direction) => {
    if (!track) return;
    const amount = Math.max(track.clientWidth * 0.85, 160);
    track.scrollBy({ left: amount * direction, behavior: "smooth" });
  };

  if (prev) prev.addEventListener("click", () => scrollTrack(-1));
  if (next) next.addEventListener("click", () => scrollTrack(1));

  root.querySelectorAll(".cart__gwp-size").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.disabled || btn.classList.contains("is-unavailable")) return;
      const card = btn.closest(".cart__gwp-card");
      if (!card) return;
      card.querySelectorAll(".cart__gwp-size").forEach((size) => size.classList.remove("is-selected"));
      btn.classList.add("is-selected");
      const addBtn = card.querySelector(".add-gift-to-cart");
      if (addBtn) {
        addBtn.dataset.variantId = btn.dataset.variantId || "";
        addBtn.disabled = !btn.dataset.variantId;
      }
      const label = card.querySelector(".cart__gwp-size-label");
      if (label && btn.dataset.size) {
        label.textContent = `Size: ${btn.dataset.size}`;
      }
    });
  });
}

window.hydrateGwpImages = hydrateGwpImages;
window.mountCartGwpCarousel = function mountCartGwpCarousel() {
  const roots = document.querySelectorAll(".cart__gwp-cards");
  roots.forEach((root) => {
    hydrateGwpImages(root);
    bindCartGwpCarousel(root);
  });
  if (!roots.length) hydrateGwpImages(document);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => window.mountCartGwpCarousel());
} else {
  window.mountCartGwpCarousel();
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // handle not showing cart drawer if in cart page
    if (window.location.href.indexOf("cart") > -1) {
      window.location.replace("/cart");
      return;
    }

    // Dispatch event to notify cart opened
    document.dispatchEvent(new CustomEvent("cart:opened"));

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      if (typeof window.mountCartGwpCarousel === "function") {
        window.mountCartGwpCarousel();
      }
    });

    this.addEventListener(
      "transitionend",
      () => {
        if (typeof window.mountCartGwpCarousel === "function") {
          window.mountCartGwpCarousel();
        }
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.syncEmptyState();

    document.dispatchEvent(new CustomEvent("countdown:restart"));
    document.dispatchEvent(new CustomEvent("mini-countdown:restart"));

    if (typeof window.mountCartGwpCarousel === "function") {
      window.mountCartGwpCarousel();
    }

    setTimeout(() => {
      const overlay = this.querySelector("#CartDrawer-Overlay");
      if (overlay) overlay.addEventListener("click", this.close.bind(this));
      this.open();
    });
  }

  syncEmptyState() {
    const hasItems = Boolean(this.querySelector(".cart-item"));
    this.classList.toggle("is-empty", !hasItems);

    const drawerInner = this.querySelector(".drawer__inner");
    if (drawerInner) drawerInner.classList.toggle("is-empty", !hasItems);

    const cartDrawerItems = this.querySelector("cart-drawer-items");
    if (cartDrawerItems) cartDrawerItems.classList.toggle("is-empty", !hasItems);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

function getCheckoutPlusHost(drawer) {
  return (
    (drawer && drawer.querySelector("checkout-plus")) ||
    document.querySelector("checkout-plus")
  );
}

function getCheckoutPlusShadowButton(host, id) {
  if (!host || !host.shadowRoot) return null;
  return host.shadowRoot.querySelector(`#${id}`);
}

function getCheckoutPlusInfoControl(host) {
  if (!host || !host.shadowRoot) return null;

  const root = host.shadowRoot;
  const match =
    root.querySelector("#info-icon-img") ||
    root.querySelector(".info-icon") ||
    root.querySelector("[part='info-icon']") ||
    root.querySelector("button[aria-label*='info' i]") ||
    Array.from(root.querySelectorAll("button, [role='button']")).find((el) => {
      const label = `${el.getAttribute("aria-label") || ""} ${el.className || ""}`.toLowerCase();
      return label.includes("info") || el.querySelector("#info-icon-img, .info-icon");
    });

  if (!match) return null;
  return match.closest("button, [role='button']") || match;
}

function openCheckoutPlusInfo(drawer) {
  const host = getCheckoutPlusHost(drawer);
  const infoControl = getCheckoutPlusInfoControl(host);
  if (!infoControl) return false;
  infoControl.click();
  return true;
}

function syncCheckoutPlusPrice(drawer) {
  const host = getCheckoutPlusHost(drawer);
  const priceEl = drawer && drawer.querySelector("[data-checkout-plus-price]");
  const offerEl = drawer && drawer.querySelector("[data-checkout-plus-offer]");
  if (!offerEl) return;

  if (!host || host.getAttribute("hide") === "true") {
    offerEl.hidden = true;
    return;
  }

  offerEl.hidden = false;
  const label = getCheckoutPlusShadowButton(host, "price-label");
  if (priceEl && label && label.textContent.trim()) {
    priceEl.textContent = label.textContent.trim();
  }
}

function submitShopifyCheckout(drawer) {
  const form = drawer.querySelector("#CartDrawer-Form");
  if (form) {
    const submitter = document.createElement("button");
    submitter.type = "submit";
    submitter.name = "checkout";
    submitter.hidden = true;
    form.appendChild(submitter);
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit(submitter);
    } else {
      form.submit();
    }
    submitter.remove();
    return;
  }

  window.location.href = "/checkout";
}

function bindCartDrawerCheckoutPlus() {
  if (window.__bbCheckoutPlusBound) return;
  window.__bbCheckoutPlusBound = true;

  document.addEventListener(
    "click",
    (event) => {
      const infoBtn = event.target.closest(".cart-drawer__plus-info");
      if (infoBtn) {
        const drawer = infoBtn.closest("cart-drawer");
        if (drawer && drawer.classList.contains("cart-drawer--checkout-plus")) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openCheckoutPlusInfo(drawer);
        }
        return;
      }

      const checkoutBtn = event.target.closest("#CartDrawer-CheckoutCta");
      if (!checkoutBtn || checkoutBtn.disabled) return;

      const drawer = checkoutBtn.closest("cart-drawer");
      if (!drawer || !drawer.classList.contains("cart-drawer--checkout-plus")) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const toggle = drawer.querySelector("#CartDrawer-CheckoutPlusToggle");
      const usePlus = Boolean(toggle && toggle.checked);
      const host = getCheckoutPlusHost(drawer);
      const plusButton = usePlus ? getCheckoutPlusShadowButton(host, "primary-button") : null;

      if (plusButton) {
        plusButton.click();
        return;
      }

      submitShopifyCheckout(drawer);
    },
    true
  );

  const refresh = () => {
    document.querySelectorAll("cart-drawer.cart-drawer--checkout-plus").forEach(syncCheckoutPlusPrice);
  };

  refresh();
  document.addEventListener("cart:opened", refresh);

  let refreshTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindCartDrawerCheckoutPlus);
} else {
  bindCartDrawerCheckoutPlus();
}
